// extracted by mini-css-extract-plugin
export var closeButton = "_jk-1";
export var closeX = "_jk-3";
export var container = "_jk-0";
export var image = "_jk-2";